import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "account-selection" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { style: {"display":"flex"} }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { style: {"flex-grow":"1"} }, [
  /*#__PURE__*/_createElementVNode("h6", null, "Accounts")
], -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["id", "onClick"]
const _hoisted_7 = { style: {"padding":"10px","display":"flex","align-items":"center","border-bottom":"1px solid #ddd"} }
const _hoisted_8 = ["name", "checked"]
const _hoisted_9 = { style: {"display":"flex","flex-direction":"column"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel_group = _resolveComponent("panel-group")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_panel_group, null, {
        heading: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            (_ctx.selectable)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                  _createElementVNode("a", {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectAll()))
                  }, "Select all")
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accounts, (account) => {
            return (_openBlock(), _createElementBlock("div", {
              id: `sub-${account.subscriptionKey}`,
              style: {"border":"1px solid #ddd","border-bottom":"0","cursor":"pointer"},
              key: account.subscriptionKey,
              onClick: ($event: any) => (_ctx.toggle(account.subscriptionKey))
            }, [
              _createElementVNode("div", _hoisted_7, [
                (_ctx.selectable)
                  ? (_openBlock(), _createElementBlock("input", {
                      key: 0,
                      name: account.subscriptionKey,
                      type: "checkbox",
                      style: {"margin-right":"20px","cursor":"pointer"},
                      checked: _ctx.sa.includes(account.subscriptionKey)
                    }, null, 8, _hoisted_8))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", null, _toDisplayString(account.productName), 1),
                  _createElementVNode("div", null, _toDisplayString(`**** ${account.accountNumber.substring(
                    account.accountNumber.length - 4
                  )}`), 1)
                ])
              ])
            ], 8, _hoisted_6))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}